import * as React from 'react';
import style from './index.less';
import cx from 'classnames';
import lockAsync from '@src/utils/lock-async';
import LoadingIcon from '@src/components/sms-code-input/components/loading-icon';
import { getLocales } from '@src/global-locales/get-page-locales-data';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export default class SmsCodeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countDown: null,
      smsFirstTimes: 0
    };
    this.loading = false;
    this.onSmsButtonClick = this.onSmsButtonClick.bind(this);
    this.validator = props.validator;
  }

  @lockAsync()
  async onSmsButtonClick() {
    try {
      this.validator();
      const { sendCode } = this.props;
      await this.setState({ loading: true });
      const sendCodeStatus = await sendCode().catch(err => {
        this.setState({ loading: false });
        // console.error(err.msg);
      });
      await this.setState({ loading: false });
      if (sendCodeStatus && sendCodeStatus.$state === 0) {
        return;
      }
      if (sendCodeStatus) {
        await this.countDown(60);
      }
      await this.setState({ loading: false });
    } catch (e) {
      // $$tracker.clickStartCode('fail', e.message);
    }
  }

  async countDown(countDown) {
    this.setState({ smsFirstTimes: 1 });
    const nextCountDown = countDown - 1;
    if (nextCountDown < 1) {
      this.setState({ countDown: null });
      return;
    }
    this.setState({ countDown: nextCountDown });
    await delay(1000);
    await this.countDown(nextCountDown);
  }

  renderButton() {
    let { buttonText = '获取验证码' } = this.props;
    const { loading, countDown } = this.state;
    const { children } = this.props;
    let isNotFirstSend = this.state.smsFirstTimes;

    // console.log('countDown: ', countDown);
    if (countDown === null) {
      buttonText = !isNotFirstSend ? buttonText : getLocales('reserve.form.resend');
    } else {
      buttonText = `${countDown} ${getLocales('reserve.logic.vcode_countdown')}`;
    }
    // buttonText = countDown === null ? buttonText : `${countDown} 秒后重试`;
    if (loading) {
      return <LoadingIcon />;
    }
    return (
      <div className={style.btn} onClick={this.onSmsButtonClick}>
        {children}
        <div className={cx(style.sendButton, countDown !== null && style.noCursor)}>{buttonText}</div>
      </div>
    );
  }

  componentWillUnmount() {
    sessionStorage.removeItem('smsFirstTimes');
  }

  componentDidMount() {
    // console.log('mount');
    this.buttonText = getLocales('reserve.form.get_code');
  }

  render() {
    // noinspection JSUnusedLocalSymbols
    const { validateAndGetPhone, codeBtnClassName, ...restProps } = this.props;
    const { countDown } = this.state;
    return (
      <div className={style.smsCodeInput}>
        <div className={cx(style.smsButton, codeBtnClassName, countDown && style.btnDisable)}>{this.renderButton()}</div>
      </div>
    );
  }
}
